import { Button } from "@/components/ui";
import { cn } from "@/lib/utils";

type CreationMode = "standard" | "ai" | "future";

interface ModeToggleProps {
  creationMode: CreationMode;
  isToggleDisabled: boolean;
  onModeChange: (mode: CreationMode) => void;
}

export function ModeToggle({ creationMode, isToggleDisabled, onModeChange }: ModeToggleProps) {
  return (
    <div
      className={cn(
        "sticky top-[120px] z-40 mx-4 mb-4 flex items-center justify-center border-b border-gray-300 bg-white py-3 md:mx-0"
      )}
    >
      <div className="flex rounded-lg border border-gray-300 bg-white p-1">
        <Button
          size="sm"
          variant={creationMode === "standard" ? "default" : "ghost"}
          onClick={() => onModeChange("standard")}
          disabled={isToggleDisabled}
          className="px-3 py-1.5"
        >
          Standard
        </Button>
        <Button
          size="sm"
          variant={creationMode === "ai" ? "default" : "ghost"}
          onClick={() => onModeChange("ai")}
          disabled={isToggleDisabled}
          className="px-3 py-1.5"
        >
          AI Agent
        </Button>
        <Button
          size="sm"
          variant={creationMode === "future" ? "default" : "ghost"}
          onClick={() => onModeChange("future")}
          disabled={isToggleDisabled}
          className="px-3 py-1.5"
        >
          Future Option
        </Button>
      </div>
    </div>
  );
}
